import {
  MenuFormSubmitHandler,
  MenuSubmitHandlersMap,
  Mode,
  PartialMenu
} from '../../../../interfaces/meMenuInterfaces/interfaces';
import {useCallback} from 'react';
import {FormikHelpers} from 'formik';

type FormikSubmitHandler = (
  values: Parameters<MenuFormSubmitHandler>[0],
  helpers: FormikHelpers<Parameters<MenuFormSubmitHandler>[0]>
) => Promise<void>;

export const useSubmitByMode = (
  mode: Mode,
  submitters?: MenuSubmitHandlersMap,
  menu?: PartialMenu,
  onAfterSuccess?: () => void
) => useCallback<FormikSubmitHandler>(
  async (values, helpers) => {
    try {
      const fn= mode ? submitters?.[mode] : undefined;
      if (!fn) return;
      await fn(values, helpers, { menu });
      onAfterSuccess?.();
    } finally {
      helpers.setSubmitting(false);
    }
  },
  [mode, submitters, menu, onAfterSuccess]
);